import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';
import type { NotificationItem } from '@/api/notifications';

interface Props {
  notification: NotificationItem;
  onDismiss: () => void;
  onRead: (id: string) => void;
}

function getEntityPath(entityType: string, entityId: string): string | null {
  switch (entityType) {
    case 'JOB':
      return `/jobs/${entityId}`;
    case 'INQUIRY':
      return `/inquiries/${entityId}`;
    case 'APPOINTMENT':
      return '/appointments';
    default:
      return null;
  }
}

export default function NotificationToast({ notification, onDismiss, onRead }: Props) {
  const navigate = useNavigate();

  const handleClick = () => {
    onRead(notification.id);
    onDismiss();
    const path = getEntityPath(notification.entityType, notification.entityId);
    if (path) navigate(path);
  };

  return (
    <div className="fixed top-4 right-4 z-[60] animate-in slide-in-from-top-2 fade-in duration-300">
      <div
        onClick={handleClick}
        className="bg-card border border-border rounded-xl shadow-2xl px-4 py-3 max-w-xs cursor-pointer hover:bg-accent transition-colors"
      >
        <div className="flex items-start gap-3">
          <span className="w-2 h-2 rounded-full bg-blue-500 mt-1.5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-foreground leading-tight truncate">
              {notification.title}
            </p>
            <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">{notification.body}</p>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDismiss();
            }}
            className="text-muted-foreground hover:text-foreground p-0.5 -mr-1 -mt-0.5"
          >
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
